import { useState } from "react";
import { format, parseISO } from "date-fns";
import { CalendarDays } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";
import { fmtDMY } from "@/lib/utils";

export function DateField({ value, onChange, min, testid, className = "" }) {
  const [open, setOpen] = useState(false);
  const selected = value ? parseISO(value) : undefined;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testid}
          className={`flex h-9 w-full items-center justify-between rounded-md border border-input bg-transparent px-3 text-sm shadow-sm transition-colors duration-200 hover:bg-muted/40 ${className}`}>
          <span className={value ? "" : "text-muted-foreground"}>{value ? fmtDMY(value) : "dd/mm/yyyy"}</span>
          <CalendarDays className="h-4 w-4 text-muted-foreground" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start" data-testid={`${testid}-calendar`}>
        <Calendar mode="single" selected={selected} defaultMonth={selected} weekStartsOn={1}
          disabled={min ? { before: parseISO(min) } : undefined}
          onSelect={(d) => { if (d) { onChange(format(d, "yyyy-MM-dd")); setOpen(false); } }} initialFocus />
      </PopoverContent>
    </Popover>
  );
}
